import {
    GET_DISTRICTS,
    GET_PROVIDENCE,
    GET_SERVICE_CONFIG,
    RESET_SERVICE_DATA,
    SET_ADDRESS_FORM_DATA,
    SET_NOTE_FORM_DATA,
    SET_USERINFO_FORM_DATA,
    SET_SERVICE_CENTERS, SET_TIME_FORM_DATA, SET_TYPE_FORM_DATA, GET_QUARTERS
} from '../constants/actionTypes'
const initialState = {providence:[],districts:[]};

const serviceAppointmentReducer = (state = initialState, action) => {
    switch (action.type) {

            case GET_PROVIDENCE:
            return {
                ...state,
                providences: [...action.payload]
            }

        case GET_DISTRICTS:
            return {
                ...state,
                districts: [...action.payload]
            }

            case GET_QUARTERS:
                return {
                    ...state,
                    quarters: [...action.payload]
                }

        case GET_SERVICE_CONFIG:
            return {
                ...state,
                service_configs:{...action.payload}
            }

        case SET_ADDRESS_FORM_DATA:
            return {
                ...state,
                application_form: {...state.application_form,address: {...action.payload}}
            }

            case SET_TIME_FORM_DATA:
            return {
                ...state,
                application_form: {...state.application_form,time: {...action.payload}}
            }
            case SET_TYPE_FORM_DATA:
                return {
                    ...state,
                    application_form: {...state.application_form,type: {...action.payload}}
                }
            case SET_NOTE_FORM_DATA:
            return {
                ...state,
                application_form: {...state.application_form,note: {...action.payload}}
            }

            case SET_USERINFO_FORM_DATA:
            return {
                ...state,
                application_form: {...state.application_form,user_info: {...action.payload}}
            }

            case RESET_SERVICE_DATA:
            return {
                ...state,
                application_form:{},
            }

        case SET_SERVICE_CENTERS :
            return {
                ...state,
                serviceCenters:action.payload
            }
        default:
            return state;
    }
};

export default serviceAppointmentReducer;